var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('button',{ref:"button",staticClass:"btn btn-link",attrs:{"type":"button","data-bs-toggle":"tooltip","data-bs-placement":"bottom","data-bs-html":"true","data-bs-trigger":"hover focus","title":_vm.title}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }